import React from 'react';

const BASENAME = process.env.PUBLIC_URL;

const ProjectCellRenderer = (params) => {
    const {value, data} = params;
    const {has_project_permission, ibge, id} = data;

    const openProject = () => {
        if (has_project_permission) {
            window.open(`${BASENAME}/projects/form/${id}`, `${ibge}-name`);
        }
    }

    return (
        <div className={has_project_permission ? "text-blue-700 w-full hover:underline" : ""} onClick={openProject}>
            {value}
        </div>
    );
};

export default ProjectCellRenderer;